<template>
  <div class="home">
    <NavigationBar />
    <Breadcrumb breadcrumbText="Contact Us" />
    <Map />
    <SendMessage />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Map from "@/components/Map.vue";
import SendMessage from "@/components/SendMessage.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "contact",
  components: {
    NavigationBar,
    Breadcrumb,
    Map,
    SendMessage,
    Footer
  }
};
</script>
